/**
 * Browser / webpack entry point for @landlordops/shared.
 *
 * Exports ONLY the Zod-free utilities that the frontend actually uses:
 *   - Tier resolution & grandfathering helpers
 *   - Pure TypeScript types (erased at compile time, zero runtime cost)
 *
 * Zod schemas are intentionally excluded.  They are only needed on the
 * backend for request validation, and Zod 3.25's ESM-first packaging causes
 * CommonJS interop issues in Create React App / Webpack 5 builds.
 *
 * Backend / Node code continues to import from the default entry (index.ts)
 * which includes the full schema set.
 */

// ── Tier logic ────────────────────────────────────────────────────────────────
export {
  isOpsChatStylePlanKey,
  extractRawPlanKey,
  normalizeTierKey,
  subscriptionAllowsGrandfatheredScale,
  isGrandfatheredScaleSuite,
  resolveUserTier,
  getUnitCapForTier,
  UNIT_CAPS,
} from "./utils/tier-logic";
export type { TierKey } from "./utils/tier-logic";

// ── Lease utilities (pure functions, no Zod) ───────────────────────────────
export { getLeaseOwnerId, getLeaseRentDollars, isLeaseActive } from "./types/lease";
